module.exports = __webpack_public_path__ + "img/Wp_2012.8f97af54.png";